var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmpty = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 40,
    viewBox: "0 0 84 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 1.02393H54.75V39.5239H15.25V1.02393Z",
    fill: "white",
    stroke: "#32373E",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4026 1.02393L41.0818 13.5239H2.60355L15.1036 1.02393H53.4026Z",
    fill: "#00346C",
    stroke: "#32373E",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 1.02393H73.75V39.5239H54.25V1.02393Z",
    fill: "#3396FF",
    stroke: "#32373E",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8804 28.2062C22.1312 28.2657 24.382 28.3008 26.6328 28.2482C26.6937 28.2482 26.752 28.2246 26.7951 28.1825C26.8381 28.1405 26.8623 28.0834 26.8623 28.0239C26.8623 27.9644 26.8381 27.9074 26.7951 27.8653C26.752 27.8233 26.6937 27.7996 26.6328 27.7996C24.382 27.7471 22.1312 27.7821 19.8804 27.8417C19.8309 27.8417 19.7835 27.8609 19.7485 27.8951C19.7135 27.9292 19.6938 27.9756 19.6938 28.0239C19.6938 28.0723 19.7135 28.1186 19.7485 28.1528C19.7835 28.187 19.8309 28.2062 19.8804 28.2062Z",
    fill: "#3396FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5655 1.02393L63.2097 10.5239H83.429L74.6598 1.02393H54.5655Z",
    fill: "#0052AA",
    stroke: "#32373E",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8804 30.1041C22.1312 30.1637 24.382 30.1987 26.6328 30.1462C26.6937 30.1462 26.752 30.1225 26.7951 30.0805C26.8381 30.0384 26.8623 29.9814 26.8623 29.9219C26.8623 29.8624 26.8381 29.8053 26.7951 29.7633C26.752 29.7212 26.6937 29.6976 26.6328 29.6976C24.382 29.645 22.1312 29.6801 19.8804 29.7396C19.8309 29.7396 19.7835 29.7588 19.7485 29.793C19.7135 29.8272 19.6938 29.8735 19.6938 29.9219C19.6938 29.9702 19.7135 30.0166 19.7485 30.0507C19.7835 30.0849 19.8309 30.1041 19.8804 30.1041Z",
    fill: "#3396FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8814 32.0038C21.1049 32.0618 22.3284 32.0969 23.5518 32.0442C23.6092 32.0392 23.6625 32.0135 23.7014 31.972C23.7403 31.9305 23.7618 31.8763 23.7618 31.8201C23.7618 31.7638 23.7403 31.7096 23.7014 31.6682C23.6625 31.6267 23.6092 31.6009 23.5518 31.5959C22.3284 31.5432 21.1049 31.5784 19.8814 31.6364C19.8315 31.6364 19.7837 31.6557 19.7484 31.6902C19.7132 31.7246 19.6934 31.7713 19.6934 31.8201C19.6934 31.8688 19.7132 31.9155 19.7484 31.95C19.7837 31.9844 19.8315 32.0038 19.8814 32.0038Z",
    fill: "#3396FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty.f3b751de09f143b9dedde034fa6af745.svg";